<script>
import Input from "@/pages/components/form/input-only/input.vue";
import FormGroup from "@/pages/components/form/horizontal/form-group.vue";
import MultipleRadios from "@/pages/components/form/input-only/multiple-radios.vue";
import {ref} from "vue";

export default {
	components: {MultipleRadios, Input, FormGroup},
	emits: ['update:modelValue', 'update:option'],
	props: ['testValue', 'modelValue', 'option'],
	setup(props) {
		let option = JSON.parse(!props.option ? '{}': props.option);

		const valid = ref(props.modelValue);
		const luchtsnelheid = ref(option.luchtsnelheid ?? null);
		const diameter = ref(option.diameter ?? null);

		return {
			valid: valid,
			luchtsnelheid: luchtsnelheid,
			diameter: diameter,
		}
	},
	mounted() {
		this.checkValid();
		this.$watch('luchtsnelheid', this.checkValid.bind(this, true));
		this.$watch('diameter', this.checkValid.bind(this, true));
		this.$watch('valid', this.checkValid.bind(this, true));
	},
	methods: {
		checkValid(emit = false) {
			let valid = null;
			let calculate = true;
			let result = 0;

			if (!this.luchtsnelheid || !this.diameter) {
				valid = false;
				calculate = false
			}

			if(calculate) {
				let pie = 3.1415;
				result = this.luchtsnelheid * pie * this.diameter * 900;
				valid = this.testValue <= result;
			}

			if(this.testValue > 0) {
				if(valid) {
					this.valid = 'OK';
				} else {
					this.valid = 'Fout';
				}
			}

			if(!emit) {
				return;
			}

			let option = {
				luchtsnelheid: this.luchtsnelheid,
				diameter: this.diameter,
				result: result,
			};

			this.$emit('update:modelValue', this.valid);
			this.$emit('update:option', JSON.stringify(option));
		}
	}
}
</script>

<!--@update:modelValue="this.$emit('update:form', {group: group.name, input: name, value: $event, type: 'value'})"-->
<!--@update:option="this.$emit('update:form', {group: group.name, input: name, option: $event, type: 'option'})"-->

<template>
	<FormGroup id="afzuigeenheid">
		<template #label>Meting flow debiet</template>

		<div class="d-flex align-items-center">
			<div>
				<Input
					name="luchtsnelheid"
					v-model="luchtsnelheid"
				/>
			</div>

			<div class="ps-2">
				<Input
					name="diameter"
					v-model="diameter"
				/>
			</div>

			<div class="ps-4">
				<MultipleRadios
					name="valid"
					v-model="valid"
					:options="[
          			  { label: 'OK', value: 'OK' },
          			  { label: 'Fout', value: 'Fout' },
          			]"
					:disabled="this.testValue > 0"
				/>
			</div>
		</div>
	</FormGroup>
</template>